import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const { REQUEST_GET_ALL_SUBMITTED_DOCUMENT_FOR_RESOLVER, FAILURE_GET_ALL_SUBMITTED_DOCUMENT } =
  documentationActions;

function* getAllSubmittedDocumentsForResolver(action: any): SagaReturnType<any> {
  try {
    yield call(templateService.getSubmittedDocuments, action.payload);
  } catch (error) {
    console.error(error);
  }
}

function* getAllSubmittedDocumentForResolver() {
  yield takeEvery(
    REQUEST_GET_ALL_SUBMITTED_DOCUMENT_FOR_RESOLVER,
    getAllSubmittedDocumentsForResolver
  );
}

export default getAllSubmittedDocumentForResolver;
